import React from 'react';
import { Anchor, FlexCol, FlexRow, Text, theme } from '@veeqo/ui';

export const MessageEl = ({
  preText,
  postText,
  linkText,
  href,
  jobId,
}: {
  preText?: string;
  postText?: string;
  linkText?: string;
  href?: string;
  jobId?: string;
}) => (
  <FlexCol gap="none">
    {!!preText && <Text variant="body">{preText}</Text>}
    {/* Use of a tag instead of Anchor component is temporary until Anchor supports mailto links */}
    {!!linkText && (
      <a href={href} rel="noopener noreferrer" style={{ color: theme.colors.secondary.blue.base }}>
        {`${linkText} `}
      </a>
    )}
    {!!postText && <Text variant="body">{postText}</Text>}

    {!!jobId && (
      <FlexRow style={{ marginTop: theme.sizes.md }}>
        <Text variant="bodySmallBold">Issue ID:</Text>
        <Text variant="bodySmall">{`${jobId}`}</Text>
      </FlexRow>
    )}
  </FlexCol>
);
